<template>
  <div class="right">
    <div class="info">
      <el-upload
        class="upload-btn"
        action="#"
        :auto-upload="false"
        :on-change="
          (file, fileList) => handleFileUpload(file, fileList, 'card')
        "
        :show-file-list="false"
        :before-upload="beforeUpload"
      >
        <img
          :src="avatarUrl"
          style="width: 80px; margin-left: 5px; margin-bottom: 20px"
          alt=""
        />
      </el-upload>
      <span style="font-size: 18px; color: #333333; margin-bottom: 20px">{{
        userInfo?.userName
      }}</span>
    </div>
    <div class="idNumber">
      <span style="margin-bottom: 12px"
        >{{ $t("profile.studentStaffID") }}：{{ userInfo?.loginName }}</span
      ><span style="margin-bottom: 12px"
        >{{ $t("profile.phone") }}：{{ userInfo?.phone }}</span
      >
      <span style="margin-bottom: 12px"
        >{{ $t("profile.departName") }}：{{ userInfo?.deptName }}</span
      >
    </div>
  </div>
</template>
<script>
import { getImageUrl } from "@/utils/imageHelper";
import request from "@/api/request";
import axios from "axios"; // 假设使用axios
export default {
  data() {
    return {
      avtor: require("@/assets/img/personal/avtor.png"),
      userInfo: {},
    };
  },
  computed: {
    // 计算属性方式
    avatarUrl() {
      return getImageUrl(this.avtor);
    },
  },
  created() {
    this.userInfo = {
      ...JSON.parse(localStorage.getItem("accountInfo"))?.data,
    };
    if (localStorage.getItem("avatar")) {
      this.avtor = localStorage.getItem("avatar");
      console.log("323", this.avtor);
    } else {
      this.avtor = this.userInfo.avatar;
      console.log("326", this.userInfo);
    }
  },
  destroyed(){
    localStorage.removeItem("avatar");
  },
  methods: {
    updateAvtor(data) {
      request({
        url: `/api/user/update/avatar`,
        method: "post",
        data: {
          avatar: data,
        },
      })
        .then((res) => {
          this.$message.success("修改成功");
        })
        .catch((error) => {});
    },
    handleFileUpload(file, fileList, key) {
      console.log("上传文件:", file);
      const formData = new FormData();
      formData.append("file", file.raw); // 用 file.raw（el-upload 的原生文件对象）

      axios
        .post("/api/sys/fileupload", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            // 注意：如果后端需要登录态，添加 Token（根据你的项目配置）
          },
        })
        .then((res) => {
          console.log(res);
          this.avtor = res.data.data;
          this.updateAvtor(res.data.data);
          localStorage.setItem("avatar", res.data.data);
        })
        .catch((error) => {});
    },
  },
};
</script>
<style scoped lang="scss">
.right {
  background-image: url("@/assets/img/personal/editPassBg.png");
  background-size: contain;
  background-repeat: no-repeat;
  height: 100%;
  // width: 25%;
  display: flex;
  flex-direction: column;
  align-items: center;
  .info {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 20%;
  }
  .idNumber {
    display: flex;
    flex-direction: column;
    padding: 15px;
    font-size: 14px;
    color: #666666;
    background: #f5f7fb;
    border-radius: 4px;
    width: 80%;
    margin-top: 15px;
  }
}
</style>